import validator from 'validator';

const validate = (values, props) => {
    const errors = {};
    const cmeUno = props.cmeUno;
    if (!values.email  || values.email === ""){
        errors.email = cmeUno.validationData.email.messages.required;
    } else if (!validator.isEmail(values.email)){
        errors.email = cmeUno.validationData.email.messages.invalidEmail;
    }
    if ((!values.captchaResponse || values.captchaResponse === "") && !window.grecaptcha){
        errors.captchaResponse = cmeUno.validationData.captchaResponse.messages.required;
    }
    return errors;
};

export default validate;